import { get } from 'common/utils/request';
export var fetchBenefitCompanyBalanceApi = function () {
    return get('/benefits/common/balance');
};
